import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";

interface PropertiesFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
}

const PropertiesFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
}: PropertiesFiltersProps) => (
  <div className="flex flex-col sm:flex-row gap-4">
    <div className="flex-1 relative">
      <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
      <Input
        placeholder="Buscar por título o ubicación..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
      />
    </div>

    <Select value={statusFilter} onValueChange={onStatusChange}>
      <SelectTrigger className="w-full sm:w-48">
        <SelectValue placeholder="Filtrar por estado" />
      </SelectTrigger>

      <SelectContent>
        <SelectItem value="all">Todas</SelectItem>
        <SelectItem value="available">Disponibles</SelectItem>
        <SelectItem value="unavailable">No disponibles</SelectItem>
        <SelectItem value="featured">Destacadas</SelectItem>
      </SelectContent>
    </Select>
  </div>
);

export default PropertiesFilters;
